export const generateAvatarFallback = (str: string) => {
    const regex = /^(\w).*?\s(\w)|^(\w).*?$/;
    const res = regex.exec(str);

    if (res) {
        // If there's a match with space, use the first letter of the first and second words
        if (res[1] && res[2]) {
            return res[1].toUpperCase() + res[2].toUpperCase();
        }
        // If there's only one word, use the first letter twice
        if (res[3]) {
            return res[3].toUpperCase() + res[3].toUpperCase();
        }
    }

    // Default fallback if the input doesn't match the expected pattern
    return '';
};
